import React, { Component } from 'react'
import HttpServices from '../utils/Http.services'
import FormViewer from './FormViewer'
import tableComponents from '../components/tableComponents'
import { checkTranslation } from '../utils/useful'
import moment from 'jalali-moment'

export default class HistoryViewer extends Component {
  state = {
    histories: []
  }
  componentDidMount() {
    let body = { applet: this.props.variables.applet._id, frame: this.props.frame._id, record: this.props.currentItem._id }
    HttpServices.request('getActivityLogs', body, (fetchResult, fetchError) => {
      if (fetchError) {
        return
      }
      this.setState({ histories: fetchResult.info }, () => {
        console.log('histories', this.state.histories)
      })
    })
  }
  showHistory = () => {
    console.log('showHistory', this.props.colors)
    let histories = this.state.histories
    return histories.map((element) => {
      console.log('element.action', element.activity)
      if (element.activity == 'create') {
        // let headers = []
        this.getHeaderInfo()
        return (
          <div className='' style={{}}>
            <div className='px-3 py-3 ' style={{}}>
              <p className='w-100 main-c2 font-size-16 weight-600' style={{}}>Action: {element.activity}</p>
            </div>
            <div className='w-100 px-2 py-2' style={{}}>
              <div className='w-100 br-10 px-2 py-1' style={{ backgroundColor: '#efefef90' }}>

                {element.data.values && Object.entries(element.data?.values).map(([key, value]) => {
                  let headerInfo = this.getHeaderInfo(key)

                  console.log('headerInfo', headerInfo)
                  let Component = tableComponents[headerInfo.type]
                  // data = value
                  return (
                    <div className='w-100 mt-2 px-2 py-1 flexc'  >
                      <p className='mrd-1 w-100 main-c2 font-size-14 weight-600'>{checkTranslation(headerInfo.information?.label)}: </p>
                      {/* <div > */}
                      <Component data={value} header={headerInfo} fullData={this.props.currentItem} />
                      {/* </div> */}
                    </div>
                  )
                })}

              </div>
            </div>
          </div>
        )
      }
      if (element.activity == 'update' && element.field == 'data') {
        return (
          <div className="px-3" style={{}}>
            <p className='w-100 main-c2 font-size-16 weight-600' style={{}}>Action: {element.activity}</p>
            <div className='flexc'>
              <p className='font-size-15 main-c2 weight-600 px-2 pb-1 pt-3'>oldData</p>
              <p className='font-size-15 main-c2 weight-400 px-2 pb-1 pt-3'>{moment(element.cDate).locale('en').format('YYYY-MMMM-DD ')}</p>
            </div>
            <div className='w-100 br-10 px-2 py-1' style={{ backgroundColor: '#efefef90' }}>
              {element.oldData.values && Object.entries(element.oldData?.values).map(([key, value]) => {
                let headerInfo = this.getHeaderInfo(key)

                console.log('headerInfo', headerInfo)
                let Component = tableComponents[headerInfo.type]
                return (
                  <div className='w-100 px-2 py-1 flexc' >
                    <p className='mrd-1 w-100 main-c2 font-size-14 weight-600'>{checkTranslation(headerInfo.information?.label)}: </p>
                    <Component data={value} header={headerInfo} fullData={this.props.currentItem} />
                  </div>
                )
              })}

            </div>
            <div className='pb-3' style={{ borderBottom: '1px solid #e2e2e2', }}>
              <div className='flexc'>
                <p className='font-size-15 main-c2 weight-600 px-2 pb-1 pt-3'>data</p>
                <p className='font-size-15 main-c2 weight-400 px-2 pb-1 pt-3'>{moment(element.cDate).locale('en').format('YYYY-MMMM-DD ')}</p>
              </div>
              <div className='w-100 br-10 px-2 py-1' style={{ backgroundColor: '#efefef90' }}>

                {element.data.values && Object.entries(element.data?.values).map(([key, value]) => {
                  let headerInfo = this.getHeaderInfo(key)

                  console.log('headerInfo', headerInfo)
                  let Component = tableComponents[headerInfo.type]
                  return (
                    <div className='w-100 px-2 py-1 flexc' style={{}} >
                      <p className='mrd-1 w-100 main-c2 font-size-14 weight-600'>{checkTranslation(headerInfo.information?.label)}: </p>
                      <Component data={value} header={headerInfo} fullData={this.props.currentItem} />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        )
      }
      else if (element.activity == 'update' && element.field == 'stage') {
        let Component = tableComponents['StageInput']

        return (
          <div className='px-3'>
            <p className='w-100 main-c2 font-size-16 weight-600' style={{}}>Action: {element.activity}</p>
            <div className='flexc'></div>
            <p className='font-size-15 main-c2 weight-600 px-2 pb-1 pt-3'>old stage</p>
            <div className='w-100 br-10 px-2 py-1' style={{ backgroundColor: '#efefef90' }}>
              <Component data={element.oldData['**stage']} fullData={this.props.currentItem} />
            </div>

            <p className='font-size-15 main-c2 weight-600 px-2 pb-1 pt-3'>new stage</p>
            <div className='w-100 br-10 px-2 py-1' style={{ backgroundColor: '#efefef90' }}>
              <Component data={element.data['**stage']} fullData={this.props.currentItem} />
            </div>
          </div>
        )
      }
    })
  }
  getHeaderInfo = (key) => {
    let final
    console.log('key', key)
    this.props.frame.fields.map((item) => {
      console.log('item', item)
      if (item.id == key) {
        final = item
      }
    })
    return final
  }
  render() {
    return (
      <div className='w-100 h-100 scroll-no-scrollbar' >
        {this.showHistory()}
      </div>
    )
  }
}
